var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-3 pr-3"})
}
var staticRenderFns = []

export { render, staticRenderFns }